import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkSendToSupplier = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const { t } = useTranslation();
  const { stopProcessPolling } = useProcesses();
  const bulkSentToSupplierProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkSendToSupplier,
    entity,
  );
  const bulkSentToSupplierProcess = useRecoilValue(
    activeProcessSF(bulkSentToSupplierProcessKey),
  );
  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      process: bulkSentToSupplierProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      processTitle: RydeProcessTitle.BulkSendToSupplier,
      toastSummaryOnComplete: true,
    });
  }, [bulkSentToSupplierProcess, entity, onComplete, stopProcessPolling, t]);
};
